export default __webpack_public_path__ + "static/media/08-Get-Certified.364ca0be.jpg";